import {useEffect} from "react";
import useUiStore from "../store/useUiStore.ts";

/**
 * Hook to dynamically set beforeClose handler for global modals.
 * @param shouldBlockClose A callback that returns boolean | Promise<boolean> to decide if modal should close.
 */
export const useModalBeforeClose = (shouldBlockClose: () => boolean | Promise<boolean>) => {
  const updateModalConfiguration = useUiStore((state) => state.updateModalConfiguration);

  useEffect(() => {
    updateModalConfiguration({
      beforeClose: shouldBlockClose
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldBlockClose]);
};